import { cloneElement, forwardRef, ReactNode, useState, useImperativeHandle, useRef } from "react";
import { Drawer, DrawerProps } from "antd";

export interface IDrawerBasicProps extends DrawerProps {
    elementoGatilho?:ReactNode;
}

type CloseType = ((e?:React.MouseEvent<Element, MouseEvent> | React.KeyboardEvent<Element> | React.MouseEvent<HTMLElement, MouseEvent>) => void);//NonNullable<Parameters<typeof Drawer>[0]["onClose"]>;
export interface IDrawerBasicRef {
    abrir:CloseType;
    fechar:CloseType;
}

const DrawerBasic = forwardRef<IDrawerBasicRef, IDrawerBasicProps>(function DrawerBasic(
    {
        width,
        destroyOnClose,
        elementoGatilho,
        open,
        onClose,
        onClick,
        ...props
    },
    ref
) {
    width = width ?? "100%";
    destroyOnClose = destroyOnClose ?? true;

    const usandoElementoGatilho = (elementoGatilho ?? null) !== null;
    const [ openInterno, setOpenInterno ] = useState(false);
 
    const abrir:CloseType = (e) => {
        onClick?.(e as any);
        setOpenInterno(true);
    }
    const fechar:CloseType = (e) => {
        onClose?.(e as any);
        setOpenInterno(false);
    }
     
    useImperativeHandle(ref, () => ({
        abrir : abrir,
        fechar : fechar
    }));

    return <>
        {usandoElementoGatilho && cloneElement(elementoGatilho as React.ReactElement<any>, { onClick : abrir })}

        <Drawer
            {...props}
            width={width}
            destroyOnClose={destroyOnClose}
            onClose={fechar}
            open={usandoElementoGatilho ? openInterno : open}
        />
    </>;
});

export default DrawerBasic;